import { useAuth0 } from "@auth0/auth0-react";
import { TeamPage } from "../../pages/team-page";

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (isAuthenticated) {
    return <TeamPage />;
  }

  return <button onClick={() => loginWithRedirect({appState: { success: true }})}>Log In</button>;
};

export default Login;